import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { HisSearch, HisNotificationService, HisUiService, HisAuthService } from 'hisng';
import { PublicationImportService } from '../../../service/publication-import.service';
import { PublicationImportInterfaceType } from '../../../model/publication-import-interface-type';

@Component({
    selector: 'res-publication-import-search-form',
    templateUrl: './publication-import-search-form.component.html'
})
export class PublicationImportSearchFormComponent implements OnInit, OnChanges {
    @Input() selectedInterfaceType: PublicationImportInterfaceType;
    @Input() searchParams: {[key: string]: any};
    @Output() onSubmitSearch = new EventEmitter<HisSearch>();
    @Input() callerId: string;

    private readonly RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION = 'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION';
    private readonly FS_RES_PUBLICATION_IMPORT = 'fs.res.publication.import';
    interfaceHelpText = '';
    interfaceSearchHeader = '';
    hasImportPublicationRight = false;
    validSearchConfigPath =false;

    constructor(
        private publicationImportService: PublicationImportService,
        private notificationService: HisNotificationService,
        private uiService: HisUiService,
        private auth: HisAuthService
    ) {}

    ngOnInit() {
        if(null === this.selectedInterfaceType.searchConfigurationPath ||
           this.selectedInterfaceType.searchConfigurationPath.length===0){
            console.log( 'ERROR: Missing searchConfigurationPath for the selected import interface: '+
                this.selectedInterfaceType.interfaceName);

            this.notificationService.errorI18nRes(
                'fs.res.publication.Publication.import.byinterface.badOrMissingSearchConfigPath');
        }
        else {
            this.validSearchConfigPath=true;

            this.searchParams.onlyMyPublications = true;
            this.hasImportPublicationRight = this.auth.rightsAndParameters.get(this.RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION)
                ?.get(this.FS_RES_PUBLICATION_IMPORT)
                ?.includes(this.selectedInterfaceType.interfaceName);
        }

    }


    ngOnChanges() {
        this.setInterfaceHelpText();
        this.setSearchHeader();
    }

    executeImport(search: HisSearch) {
        const searchParams: {[key: string]: string} = {};

        search.groups.forEach(g => {
            g.criteria.forEach(c => searchParams[c.field.replace('IGNORE:', '')] = c.value );
        });

        this.publicationImportService.startImport(this.selectedInterfaceType.interfaceName, searchParams).subscribe(
            () => {
                console.log('The import job has been started successfully.');
                this.notificationService.clear();
                this.notificationService.success(
                    this.uiService.translate('fs.res.interface.import.started'),
                    this.uiService.translate('messagebox.singleSuccessTitle')
                );
            },
            (error: any) => console.log(error)
        );
    }

    private setSearchHeader() {
        const specificSearchHeader = 'fs.res.interface.import.' + this.selectedInterfaceType.interfaceName + '.searchHeader';
        const generalSearchHeader = 'fs.res.interface.import.searchHeader';
        if (this.i18nKeyExists(specificSearchHeader)) {
            this.interfaceSearchHeader = this.uiService.translate(specificSearchHeader);
        } else {
            this.interfaceSearchHeader = this.uiService.translate(generalSearchHeader, this.selectedInterfaceType.systemName);
        }
    }


    private setInterfaceHelpText() {
        const specificHelpText = 'fs.res.interface.import.' + this.selectedInterfaceType.interfaceName + '.helpText';
        const generalHelpText = 'fs.res.interface.import.helpText';
        if (this.i18nKeyExists(specificHelpText)) {
            this.interfaceHelpText = this.uiService.translate(specificHelpText, this.selectedInterfaceType.documentationUrl);
        } else {
            this.interfaceHelpText = this.uiService.translate(generalHelpText, this.selectedInterfaceType.documentationUrl);
        }
    }

    private i18nKeyExists(i18nKey: string) {
        return !this.uiService.translate(i18nKey).includes(i18nKey);
    }
}
